import {
  isCordova,
} from '@/utils';

function getParameterByName(name, url) {
  const trimmedName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + trimmedName + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default class User {
  constructor(user) {
    const data = Object.assign({
      accessToken: null,
      userId: null,
      teamId: null,
    }, user);
    this.accessToken = data.accessToken;
    this.userId = data.userId;
    this.teamId = data.teamId;

    this.isLoggedIn = !!data.accessToken;
  }

  login(code = null) {
    if (code) {
      return this._getToken(code);
    }
    if (isCordova) {
      return this._authorizeCordova();
    }
    return this._authorizeWeb();
  }

  logout() {
    this.accessToken = null;
    this.userId = null;
    this.teamId = null;

    this.isLoggedIn = false;
  }

  _authorizeCordova() {
    return new Promise((resolve, reject) => {
      const url = 'https://slack.com/oauth/authorize' +
        '?client_id=195145487731.414155244596' +
        '&scope=users.profile:read,users.profile:write,channels:read,groups:read,mpim:read,im:read,chat:write:user,chat:write:bot';

      const browser = window.cordova.InAppBrowser.open(url, '_blank', 'location=no');
      browser.addEventListener('loadstart', (e) => {
        if (e.url.indexOf('https://slack-status.socket.games/') === 0) {
          const code = getParameterByName('code', e.url);
          browser.close();
          if (code) {
            this._getToken(code)
              .then(() => resolve())
              .catch(error => reject(error));
          } else {
            reject();
          }
        } else if (e.url.indexOf('https://slack.com') !== 0
          && e.url.indexOf('https://farmdok.slack.com') !== 0) {
          browser.close();
          reject();
        }
      });
      browser.addEventListener('loaderror', () => reject());
    });
  }

  _authorizeWeb() {
    return new Promise(() => {
      let url = 'https://slack.com/oauth/authorize' +
        '?client_id=195145487731.414155244596' +
        '&scope=users.profile:read,users.profile:write,channels:read,groups:read,mpim:read,im:read,chat:write:user,chat:write:bot';
      if (window.location.hostname === 'localhost') {
        url += '&redirect_uri=' + encodeURIComponent(window.location.origin + '/login');
      }
      window.location = url;
    });
  }

  _getToken(code) {
    return new Promise((resolve, reject) => {
      let url = 'https://slack.com/api/oauth.access' +
        '?client_id=195145487731.414155244596' +
        '&client_secret=9d63827d843a513d9c868780b3fcc406' +
        '&code=' + code;
      if (window.location.hostname === 'localhost') {
        url += '&redirect_uri=' + encodeURIComponent(window.location.origin + '/login');
      }
      fetch(url)
        .then((response) => {
          if (response.status !== 200) {
            console.error('error while fetching access token', response);
            reject();
          }
          response.json()
            .then((data) => {
              if (!data || !data.ok || !data.access_token || !data.scope ||
                !data.team_id || !data.user_id ||
                data.scope.indexOf('users.profile:read') < 0 ||
                data.scope.indexOf('users.profile:write') < 0) {
                console.error('incomplete response object', data);
                reject();
                return;
              }
              this.isLoggedIn = true;
              this.accessToken = data.access_token;
              this.userId = data.user_id;
              this.teamId = data.team_id;
              resolve();
            })
            .catch((error) => {
              console.error('error while fetching access token', error);
              reject();
            });
        })
        .catch((error) => {
          console.error('error while fetching access token', error);
          reject();
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/auth/User.js